let dirPath = 'static/games/page003_game1';

let configGame = {
  removeInCorrects: true,
  //autoCheckAllCorrect: true,
  correctBlock: false,
  rulesGame: {
    itemsConfig: {
      block: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'mapa',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '03',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook3' }],
          },
          {
            idGroup: 'source',
            idItem: '04',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook4' }],
          },
          {
            idGroup: 'source',
            idItem: '05',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook5' }],
          },
          {
            idGroup: 'source',
            idItem: '06',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook6' }],
          },
          {
            idGroup: 'source',
            idItem: '07',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook7' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { textAlign: 'center', bold: true },
      },
    },
    groups: [
      {
        idGroup: 'mapa',
        background: {
          color: 'transparent',
          image: { src: dirPath + '/img/target.png', pos: { x: -70, y: -10 } },
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 0, height: 750, width: 450 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: 'rgba(255,255,255, .0)',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 55, width: 213 },
                },
                items: [
                  {
                    id: 'hook3',
                    positions: { pos: { x: 26, y: 392, height: 339, width: 205 } },
                  },
                  {
                    id: 'hook4',
                    positions: { pos: { x: 224, y: 395, height: 335, width: 199 } },
                  },
                  // {
                  //   id: 'hook4',
                  //   positions: { pos: { x: 193, y: 323, height: 90, width: 60 } },
                  // },
                  {
                    id: 'hook5',
                    positions: { pos: { x: 20, y: 159, height: 265, width: 160 } },
                  },
                  {
                    id: 'hook6',
                    positions: { pos: { x: 268, y: 159, height: 265, width: 160 } },
                  },
                  {
                    id: 'hook7',
                    positions: { pos: { x: 193, y: 175, height: 170, width: 60 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        background: {
          color: 'transparent',
        },
        positions: {
          type: 'absolute',
          pos: { x: 600, y: 50 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            pos: { height: 55, width: 213 },
            margin: { right: 10 },
          },
        },
        items: [
          {
            id: '05',
            positions: {
              pos: { height: 265, width: 160 },
            },
            background: {
              image: { src: dirPath + '/img/00.png' },
            },
          },
          {
            id: '06',
            positions: {
              pos: { height: 265, width: 160 },
            },
            background: {
              image: { src: dirPath + '/img/01.png' },
            },
          },
          {
            id: '07',
            positions: {
              pos: { height: 150, width: 100 },
            },
            background: {
              image: { src: dirPath + '/img/02.png' },
            },
          },
          // {
          //   positions: {
          //     pos: { height: 150, width: 100 },
          //   },
          //   id: '04',
          //   background: {
          //     image: { src: dirPath + '/img/03.png' },
          //   },
          // },
          {
            positions: {
              pos: { height: 350, width: 205 },
            },
            id: '03',
            background: {
              image: { src: dirPath + '/img/04.png' },
            },
          },
          {
            positions: {
              pos: { height: 335, width: 199 },
            },
            id: '04',
            background: {
              image: { src: dirPath + '/img/05.png' },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  //   realHeight: 790,
  //   realWidth: 1820,
  cssStyle: {
    overlow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
